module.exports = __webpack_public_path__ + "static/media/Store_Configuration_Icon.697d41ed.svg";